import { render, staticRenderFns } from "./DisplayCommemorativeDoorplate.vue?vue&type=template&id=302a18a8&scoped=true"
import script from "./DisplayCommemorativeDoorplate.vue?vue&type=script&lang=js"
export * from "./DisplayCommemorativeDoorplate.vue?vue&type=script&lang=js"
import style0 from "./DisplayCommemorativeDoorplate.vue?vue&type=style&index=0&id=302a18a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302a18a8",
  null
  
)

export default component.exports